import React from 'react';
import { PEOPLE_ROLES, CORE_PROCESSES } from '../config/ztaArchitectureData';

const ZtaPeopleProcessLayer = () => {
  return (
    <section className="zta-layer zta-people-process">
      <div className="zta-layer-label">PEOPLE &<br/>PROCESS</div>
      <div className="zta-pp-container">
        <div className="zta-pp-roles">
          <div className="zta-pp-roles-header">PEOPLE & ROLES</div>
          <div className="zta-pp-roles-grid">
            {PEOPLE_ROLES.map((role, i) => (
              <div key={i} className="zta-pp-role">
                <div className="zta-pp-role-title">{role.title}</div>
                <div className="zta-pp-role-desc">{role.desc}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="zta-pp-processes">
          <div className="zta-pp-processes-header">CORE PROCESSES</div>
          <ul className="zta-pp-process-list">
            {CORE_PROCESSES.map((proc, i) => (
              <li key={i}>{proc}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ZtaPeopleProcessLayer;
